import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";
import { LanguageProvider } from "./LanguageContext";
import "./components/CustomCursor/script";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LanguageProvider>
    <Router>
      <App />
    </Router>
  </LanguageProvider>
);